<script lang="ts" setup></script>

<template>
  <h3 class="title">
    <slot></slot>
  </h3>
</template>

<style lang="scss" scoped>
.title {
  font-weight: 500;
  font-size: toRem(28);
  @include max-media(480) {
    font-size: toRem(20);
  }
}
</style>
